// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hd_b","colBig":"styles_colBig__2nBxa","colSmall":"styles_colSmall__2nR7O"};